import React from "react";
import "./PrivacyPolicy.css";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <>
      {/* Meta Tag for No Index */}
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>Privacy Policy | 360 Bytes</title>
      </Helmet>

      <section className="privacy-policy-section">
        <div className="container">

          <div className="privacy-policy-content">

            <h1 className="privacy-title">
              Privacy Policy
            </h1>

            <p>
              At 360-Bytes, we are committed to protecting the privacy and
              confidentiality of our users' personal information. This Privacy
              Policy outlines how we collect, use, disclose, and safeguard the
              information we gather from individuals who interact with our website
              and services.
            </p>


            <h2>Information Collection</h2>

            <p>
              We may collect personal information such as name, email address,
              contact details, or other relevant information when voluntarily
              submitted by users. Additionally, we may collect non-personal
              information such as browser type, operating system, and website
              usage details to enhance our website’s functionality and user
              experience.
            </p>


            <h2>Use of Information</h2>

            <p>We may use the collected information for purposes including:</p>

            <ul>
              <li>Providing and improving our services</li>
              <li>Responding to inquiries and requests</li>
              <li>Personalizing user experience</li>
              <li>Sending periodic emails or notifications</li>
              <li>Analyzing and enhancing website performance</li>
            </ul>


            <h2>Data Protection</h2>

            <p>
              We implement appropriate data security measures to protect against
              unauthorized access, alteration, disclosure, or destruction of
              personal information. However, no method of transmission over the
              Internet or electronic storage is entirely secure, and we cannot
              guarantee absolute security.
            </p>


            <h2>Information Sharing</h2>

            <p>
              We may share personal information with trusted third-party service
              providers who assist us in delivering our services. Such parties are
              required to maintain strict confidentiality.
            </p>

            <p>
              We do not sell, trade, or rent users’ personal information to others
              without consent, except when required by law.
            </p>


            <h2>Cookies and Tracking Technologies</h2>

            <p>
              Our website may use cookies and other tracking technologies to
              enhance user experience and analyze usage patterns. Users may
              disable cookies through their browser settings, though this may
              limit some website functionality.
            </p>


            <h2>Links to Third-Party Websites</h2>

            <p>
              Our website may contain links to third-party websites. We do not
              control their privacy practices or content and encourage users to
              review their respective policies.
            </p>


            <h2>Children’s Privacy</h2>

            <p>
              Our services are not intended for children under 13. We do not
              knowingly collect or solicit personal information from children.
              If we become aware of such information, we will delete it
              immediately.
            </p>


            <h2>Updates to the Privacy Policy</h2>

            <p>
              We reserve the right to update this Privacy Policy at any time. This
              page will reflect any changes, and users are encouraged to review
              it periodically.
            </p>


            <h2>Acceptance & Contact</h2>

            <p>
              By using our website and services, you signify your acceptance of
              this Privacy Policy. If you have any questions or concerns, please
              contact us through the provided contact information.
            </p>

          </div>

        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
